import styled, { css } from 'styled-components';
import Button from 'components/ui/Button';
import Label from 'components/ui/Label';
import { BREAKPOINTS } from 'constants/breakpoints';

import { colours } from 'themes/default';

const MOBILE_BREAKPOINT = `${BREAKPOINTS.lg.max}px`;
const SMALL_MOBILE_BREAKPOINT = `${BREAKPOINTS.sm.max}px`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  padding: 16px;
  ${({ isBackground }) =>
    isBackground
      ? css`
          background-color: ${colours.Shades.TintBlue10};
        `
      : ''}
`;

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: ${({ minWidth }) => minWidth || '180px'};
`;

export const MealsContainer = styled.div`
  display: flex;
  flex: 1;
  margin-top: 8px;
`;

export const WarningContainer = styled.div`
  display: flex;
  flex: 1;
  margin-top: 16px;
  white-space: pre-wrap;
  > div {
    padding: 8px 32px;
  }
`;

export const LoyaltyContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    align-items: flex-start;
    row-gap: 8px;
  }
`;

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 16px;
  column-gap: 16px;
`;

export const StyledPhoneWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const StyledCountryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 16px;
  width: 180px;

  @media (max-width: ${SMALL_MOBILE_BREAKPOINT}) {
    margin-right: 0;
    width: 100%;
  }
`;

export const PhoneContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: nowrap;

  @media (max-width: ${SMALL_MOBILE_BREAKPOINT}) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const SwitchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  grid-column: 8 / 10;

  > div {
    margin: 0 5px;
  }
`;
export const ConfirmButton = styled(Button)`
  div {
    align-items: center;
    display: flex;
  }
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const StyledInput = styled.input`
  display: flex;
  width: ${({ width }) => width || '100%'};
  height: 100%;
  max-height: 25px;
  outline: none;
  border-style: solid;
  border-width: 1px;
  border-color: ${({ isInvalid }) => {
    if (isInvalid) {
      return 'red';
    }

    return 'grey';
  }};
`;
export const StyledInputError = styled.div`
  display: inline-flex;
  color: red;
  font-size: 11px;
`;

export const StyledFlexWrapper = styled.div`
  display: flex;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex-wrap: wrap;
    row-gap: 8px;
  }
`;

export const CenteredFlexWrapper = styled(StyledFlexWrapper)`
  align-items: center;
`;

export const NoWrapFlexWrapper = styled(CenteredFlexWrapper)`
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    flex-wrap: nowrap;
    row-gap: 0;
  }
`;

export const StyledLabel = styled(Label)`
  display: inline-flex;
  width: ${({ width }) => width || 'unset'};
  margin-right: ${({ marginRight }) => marginRight || '0px'};
  text-align: ${({ textAlign }) => textAlign || 'unset'};
`;

export const ApplyLabel = styled.span`
  text-decoration: underline;
  text-transform: lowercase;
  font-size: 14px;
  padding-left: 8px;
  margin-left: auto;
  cursor: pointer;
  color: ${colours.Core.SecondaryPlum};
`;

export const SubmitLoyaltyNumberButton = styled(Button)`
  height: 24px;
  margin: 0 0 0 8px;

  div {
    display: flex;
    align-items: center;
    line-height: 24px;
  }
`;
